<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w" v-loading="loading">
    <p class="w100 bold mb20 font-18 tx-c">各部门排名（审批类服务）</p>

    <div class="w100 flex-box al-c sift-view">
      <DateComp ref="date" :loading="loading" @change="fetchList" />
      <div class="ml10">
        <el-button type="primary" size="mini" @click="fetchList">查询</el-button>
      </div>
    </div>

    <div class="w100 mt20 po-r serve-count-table">
      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序号" type="index" width="60px"></el-table-column>
        <el-table-column align="center" label="部门" prop="hostDept"></el-table-column>
        <el-table-column align="center" label="经办服务数量" prop="initiateNum" width="120px" sortable></el-table-column>
        <el-table-column align="center" label="办结数" prop="endNum" width="100px" sortable></el-table-column>
        <el-table-column align="center" label="办结率" prop="endRate" width="100px" sortable>
          <template slot-scope="scope">
            {{ scope.row.endRate == null ? 0 : scope.row.endRate }}%
          </template>
        </el-table-column>
        <el-table-column align="center" label="评价数" prop="appraiseNum" width="100px" sortable></el-table-column>
        <el-table-column align="center" label="服务质量得分" prop="avgScoreDuration" width="120px" sortable>
          <template slot-scope="scope">
            {{ scope.row.avgScoreDuration == null ? '-' : scope.row.avgScoreDuration }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="办理时长得分" prop="avgScoreQuality" width="120px" sortable>
          <template slot-scope="scope">
            {{ scope.row.avgScoreQuality == null ? '-' : scope.row.avgScoreQuality }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="时长" prop="avgTakeTime" width="160px" sortable>
          <template slot-scope="scope">
            {{ scope.row.avgTakeTime | costTime }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import DateComp from "@/components/ServeCount/DateComp";

export default {
  name: "ServeCountForDept",
  components: {
    DateComp
  },
  props: ["queryRang"],
  data() {
    return {
      loading: false,

      list: []
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;

      const date = this.$refs.date.getValue();
      this.$http
        .post(
          `serveCount/deptRanking`,
          JSON.stringify({
            startDate: date[0],
            endDate: date[1],
            queryRang: this.queryRang
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          }
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resCode == "0") {
            this.list = data.resData.list;
            this.loading = false;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
            this.loading = false;
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "页面请求错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>
